import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { SharedComponentsModule } from "@stockcare-components/shared-components.module";
import { MessagesDetailDialogComponent } from "./messages-detail-dialog/messages-detail-dialog.component";
import { FormBuilder, FormsModule } from "@angular/forms";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatTableModule } from "@angular/material/table";
import { MatDialogModule } from "@angular/material/dialog";



@NgModule({
  imports: [
    CommonModule,
     SharedComponentsModule,
     FormsModule,
     MatFormFieldModule,   // Required for mat-form-field
    MatInputModule,       // Required for matInput
    MatTableModule,       // Required for mat-table
    MatDialogModule
  ],
  declarations: [
    MessagesDetailDialogComponent,
  ],
  providers: [],
})
export class MessagesModule {}
